 document.addEventListener('DOMContentLoaded', () => {

 let variantPriceMap = {};

  // First, try to extract product data from an embedded JSON script.
  const productJsonScript = document.querySelector('script[type="application/json"][id^="ProductJson-"]');
  if (productJsonScript) {
    try {
      const productData = JSON.parse(productJsonScript.textContent);
      if (productData.variants && Array.isArray(productData.variants)) {
        productData.variants.forEach(variant => {
          // Assuming variant.title is something like "Pack of 9"
          // and variant.price is the price (adjust if the price is in cents)
          variantPriceMap[variant.title] = parseFloat(variant.price);
        });
      }
    } catch (e) {
      console.error('Error parsing product JSON:', e);
    }
  }

  // If we didn't get data from the JSON, try to get it from a <select> inside <noscript> tags.
  if (Object.keys(variantPriceMap).length === 0) {
    let selectElement = null;
    const noscriptElements = document.querySelectorAll('noscript');
    noscriptElements.forEach(ns => {
      // Only process if we haven't found a select yet
      if (!selectElement) {
        const parser = new DOMParser();
        const nsDoc = parser.parseFromString(ns.innerHTML, 'text/html');
        selectElement = nsDoc.querySelector('select.select--native');
      }
    });

    if (selectElement) {
      const options = selectElement.querySelectorAll('option');
      options.forEach(option => {
        // Expected text format: "Pack of 9 - Rs. 297.00"
        const text = option.textContent || '';
        const parts = text.split('-');
        if (parts.length === 2) {
          const variantName = parts[0].trim();
          const priceStr = parts[1].trim().replace("Rs.", "");


          aaa = priceStr.replace(/[^0-9.]/g, '')

          const priceNumber = parseFloat(aaa);

          if (variantName && !isNaN(priceNumber)) {
            variantPriceMap[variantName] = priceNumber;
          }
        }
      });
    } else {
      console.warn('Select element not found in any <noscript> tag.');
    }
  }

  // Now, find each variant label and add the per-item price badge.
  const variantLabels = document.querySelectorAll('.variant-picker__option-values label');
  max_price_per_item = 100000;
  max_badge = 0;
  max_price_variant = 0;
  variantLabels.forEach(label => {
    const span = label.querySelector('span');
    if (!span) return;

    const variantText = span.textContent.trim(); // e.g., "Pack of 9"
    const totalPrice = variantPriceMap[variantText];
    if (!totalPrice) return;

    // Extract the quantity from the text "Pack of X"
    const match = variantText.match(/(\d+)/);
    if (!match) return;
    const quantity = parseInt(match[1], 10);
    const pricePerItem = totalPrice / quantity;
//    span.textContent = `${span.textContent} (₹${pricePerItem.toFixed(2)} each)`;
    // Create a badge to display the per-item price.
    const badge = document.createElement('span');
    badge.textContent = "Best Value";
    badge.style.position = 'absolute';
    badge.style.top = '-10px';
    badge.style.right = '-10px';
    badge.style.fontSize = '0.6rem';
//    badge.style.backgroundColor = '#f4f4f4';
//    badge.style.padding = '2px 4px';
//    badge.style.borderRadius = '4px';
    badge.classList = ["badge badge--on-sale"]

    // Ensure the label is relatively positioned for correct absolute positioning of the badge.
    label.style.position = 'relative';
    console.log("price per item " + pricePerItem)
    console.log("max_price_per_item " + max_price_per_item)
    if (pricePerItem < max_price_per_item) {
        max_price_variant = label
        max_badge = badge
        max_price_per_item = pricePerItem
    }
//    label.appendChild(badge);
  });
  if (max_price_variant != 0) {
    max_price_variant.appendChild(max_badge)
    }

  });